import React from "react";

const scoreTone = (score) => {
  if (score === null || score === undefined) {
    return "text-gray-400 border-gray-200 bg-gray-50";
  }

  if (score >= 70) {
    return "text-green-700 border-green-200 bg-green-50";
  }

  if (score >= 40) {
    return "text-amber-700 border-amber-200 bg-amber-50";
  }

  return "text-red-700 border-red-200 bg-red-50";
};

const PaUsageScoreRing = ({ score, size = "md" }) => {
  const dimensions = size === "sm" ? "h-10 w-10 text-xs" : "h-14 w-14 text-sm";
  const label = score === null || score === undefined ? "—" : `${score}`;

  return (
    <div
      className={`inline-flex items-center justify-center rounded-full border font-semibold ${dimensions} ${scoreTone(score)}`}
      aria-label={score === null || score === undefined ? "Score unavailable" : `Usage score ${score}`}
    >
      {label}
    </div>
  );
};

export default PaUsageScoreRing;
